export const usBanks = [
    { name: 'ECCU', headquarters: 'New York, NY' },
    { name: 'Ally Financial', headquarters: 'Detroit, MI' },
    { name: 'American Express', headquarters: 'New York, NY' },
    { name: 'BMO Harris Bank', headquarters: 'Chicago, IL' },
    { name: 'BBVA USA', headquarters: 'Birmingham, AL' },
    { name: 'Bank of America', headquarters: 'Charlotte, NC' },
    { name: 'Barclays US', headquarters: 'Wilmington, DE' },
    { name: 'Capital One', headquarters: 'McLean, VA' },
    { name: 'Charles Schwab Corporation', headquarters: 'San Francisco, CA' },
    { name: 'Citigroup', headquarters: 'New York, NY' },
    { name: 'Citizens Financial Group', headquarters: 'Providence, RI' },
    { name: 'Comerica', headquarters: 'Dallas, TX' },
    { name: 'Fifth Third Bank', headquarters: 'Cincinnati, OH' },
    { name: 'Goldman Sachs', headquarters: 'New York, NY' },
    { name: 'HSBC Bank USA', headquarters: 'New York, NY' },
    { name: 'Huntington Bancshares', headquarters: 'Columbus, OH' },
    { name: 'JPMorgan Chase & Co.', headquarters: 'New York, NY' },
    { name: 'KeyBank', headquarters: 'Cleveland, OH' },
    { name: 'M&T Bank', headquarters: 'Buffalo, NY' },
    { name: 'Morgan Stanley', headquarters: 'New York, NY' },
    { name: 'Northern Trust', headquarters: 'Chicago, IL' },
    { name: 'PNC Financial Services', headquarters: 'Pittsburgh, PA' },
    { name: 'Regions Financial Corporation', headquarters: 'Birmingham, AL' },
    { name: 'Santander Bank', headquarters: 'Boston, MA' },
    { name: 'SunTrust Banks', headquarters: 'Atlanta, GA' },
    { name: 'Synchrony Financial', headquarters: 'Stamford, CT' },
    { name: 'TD Bank, N.A.', headquarters: 'Cherry Hill, NJ' },
    { name: 'Truist Financial', headquarters: 'Charlotte, NC' },
    { name: 'U.S. Bancorp', headquarters: 'Minneapolis, MN' },
    { name: 'Wells Fargo', headquarters: 'San Francisco, CA' },
    { name: 'Zions Bancorporation', headquarters: 'Salt Lake City, UT' }
  ];